/* @flow */
import { reduxDispatcher } from 'lib/Dispatcher';
import { showToast, showAPIErrorToast } from 'reducers/toasts';

// If you can, use the toasts redux actions:
//
// import {showToast} from 'reducers/toasts';
// import {bindActionCreators} from 'redux';
// import {connect} from 'react-redux';
//
// const SomeComponent = (props) => {
//   return (
//     <span onClick={() => props.showToast('hello', 'success')}>
//       click me
//     </span>
//   );
// }
//
// function mapDispatchToProps(dispatch: Function) {
//   return bindActionCreators({showToast}, dispatch);
// }
//
// export default connect(undefined, mapDispatchToProps)(SomeComponent)

// TODO - rm this file!
const ToastActions = {
  showSuccessToast(message: string): void {
    reduxDispatcher.dispatch(showToast(message, 'success'));
  },

  showErrorToast(message: string): void {
    reduxDispatcher.dispatch(showToast(message, 'error'));
  },

  showAPIError(error: any): void {
    reduxDispatcher.dispatch(showAPIErrorToast(error));
  },

  showDefaultErrorToast(): void {
    reduxDispatcher.dispatch(showToast('An error occurred.', 'error'));
  },
};

export default ToastActions;



// WEBPACK FOOTER //
// ./src/actions/ToastActions.js